export default __webpack_public_path__ + "static/media/factory__52.b7dc2b2e.jpg";